import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
export const hostUrl = (process.env.REACT_APP_API_HOSTURL || "").replace(/\/$/, "");

// Stored paths ("/uploads/x.jpg") → a URL the browser can load.
export const mediaUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//.test(path)) return path;
  return `${hostUrl}${path.startsWith("/") ? "" : "/"}${path}`;
};

/**
 * Uploads one image (admin cookie auth). Resolves to its stored path
 * ("/uploads/…"), or throws with the API's message (size/type limits).
 */
export async function uploadImage(file) {
  const form = new FormData();
  form.append("image", file);
  try {
    const res = await axios.post(`${apiUrl}admin/upload/image`, form, { withCredentials: true });
    if (!res.data?.success) throw new Error(res.data?.message || "Upload failed");
    return res.data.url;
  } catch (err) {
    throw new Error(err.response?.data?.message || err.message || "Upload failed");
  }
}
